export default __webpack_public_path__ + "static/media/icone-notas-fiscais.4467fb38.svg";